import { FC } from "react";

type GeoIconProps = {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
} & React.SVGProps<SVGSVGElement>;

export const GeoIcon: FC<GeoIconProps> = ({ 
  fill = "#DFC091", 
  stroke,
  width = "14", 
  height = "17",
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.347 0.467773C3.76236 0.467773 0.85643 3.3737 0.85643 6.95834C0.85643 7.88312 1.16711 8.93325 1.62679 9.96455C2.08964 11.003 2.71937 12.0572 3.39372 13.0005C4.06753 13.9429 4.79497 14.7872 5.45946 15.4013C5.79113 15.7079 6.11632 15.9657 6.41908 16.1496C6.70948 16.326 7.03259 16.4678 7.347 16.4678C7.66141 16.4678 7.98451 16.326 8.27491 16.1496C8.57767 15.9657 8.90286 15.7079 9.23454 15.4013C9.89902 14.7872 10.6265 13.9429 11.3003 13.0005C11.9746 12.0572 12.6044 11.003 13.0672 9.96455C13.5269 8.93325 13.8376 7.88312 13.8376 6.95834C13.8376 3.3737 10.9316 0.467773 7.347 0.467773ZM4.78096 6.95832C4.78096 5.54114 5.92981 4.39228 7.347 4.39228C8.76418 4.39228 9.91303 5.54114 9.91303 6.95832C9.91303 8.3755 8.76418 9.52436 7.347 9.52436C5.92981 9.52436 4.78096 8.3755 4.78096 6.95832Z" fill={fill} stroke={stroke} />
  </svg>
);